import React from "react";
import CoppaStrategy from "../../coppa-strategy";
import EnterVerificationCodeForm from "./enter-verification-code-form";
import EnterSecretQuestionAnswerForm from "./enter-secret-question-answer-form";

const EnterVerificationDataForm = () => (
  <CoppaStrategy
    coppaComponent={EnterSecretQuestionAnswerForm}
    nonCoppaComponent={EnterVerificationCodeForm}
  />
);

export default EnterVerificationDataForm;
